import React from 'react';
import I18n from 'js/components/generic/I18n';
import styles from './Aliases.module.css';

// A regular space char used as trailing space in the <li> text
// would be stripped by browser rendering.
const punctuationSpace = '\u2008';

interface Props {
  aliases: string[];
}

export function Aliases(props: Props): React.ReactElement | null {
  const { aliases } = props;

  if (aliases.length === 0) {
    return null;
  }

  const aliasesLastIndex = aliases.length - 1;
  const generatedAliases = aliases.map((alias, index) => {
    const comma = index < aliasesLastIndex ? `,${punctuationSpace}` : '';

    return `${alias}${comma}`;
  });

  return (
    <div className={styles.aliases}>
      <I18n path="aliases.label" />
      {punctuationSpace}
      <h2 className={styles.items}>{generatedAliases}</h2>
    </div>
  );
}
